var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4922b6b813fb631b27717351d32e1793712170e0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["earthnodesnet@sole-trader-tp"]={id:"4922b6b813fb631b27717351d32e1793712170e0"};
      